import { forwardRef } from "react";
import {
  type GetProps,
  Dialog as TamaguiDialog,
  type TamaguiElement,
} from "tamagui";

type DialogContentProps = GetProps<typeof TamaguiDialog.Content>;

/**
 * Tamagui v2's `Dialog.Content` `unstyled: false` variant hardcodes
 * `borderWidth: 1`, to override a variant style we must pass a prop override
 */
const DialogContent = forwardRef<TamaguiElement, DialogContentProps>(
  (props, ref) => (
    <TamaguiDialog.Content ref={ref} borderWidth={0} {...props} />
  ),
);
DialogContent.displayName = "DialogContent";

// Object assign instead of withStaticProperties to avoid mutating the original Dialog
export const Dialog = Object.assign({}, TamaguiDialog, {
  Content: DialogContent,
}) as typeof TamaguiDialog;
